module.exports = __webpack_public_path__ + "img/snwd.0bb4b30c.png";